import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import axios from "axios";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";

function Dashboard() {
  const [statisticsData, setStatisticsData] = useState(null);
  const user_id = localStorage.getItem("user_id");
  const auth = localStorage.getItem("authToken");
  const userRole = localStorage.getItem("role");

  // Function to fetch dashboard statistics data
  const fetchStatisticsData = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_BASEURL}/admin/users/dashboard`, {
        user_id: user_id,
      },
      {
        headers: {
          Authorization: `Bearer ${auth}`,
        },
      });

      if (response.data.success) {
        setStatisticsData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching statistics data:", error);
    }
  };

  // Fetch statistics data when the component mounts
  useEffect(() => {
    fetchStatisticsData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
        {userRole === "superadmin" && (
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                icon="admin_panel_settings"
                title="Number of Admins"
                count={statisticsData?.admin_cont}
              />
            </MDBox>
          </Grid>
        )}

        {userRole === "admin" && (
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                icon="person_search"
                title="Number of Sub Admins"
                count={statisticsData?.admin_cont}
              />
            </MDBox>
          </Grid>
        )}

          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="devices"
                title="Number of Total Devices"
                count={statisticsData?.device_count}
              />
            </MDBox>
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="done_all"
                title="Number of Alloted Devices"
                count={statisticsData?.alloted_device_count}
              />
            </MDBox>
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="offline_bolt"
                title="Number of Available Devices"
                count={statisticsData?.device_count - statisticsData?.alloted_device_count}
              />
            </MDBox>
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="warning"
                icon="pending_actions"
                title="Pending Tickets"
                count={statisticsData?.ticket_count}
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Dashboard;
